export default __webpack_public_path__ + "static/media/twitter.002230e2.svg";